import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getLiveFAQs, getLiveTopicInfo } from 'reduxModules/live/selector';
import { openSocialWidget } from 'reduxModules/socialWidget/action';

import Accordion from 'components/Accordion';
import { QuestionIcon } from 'components/Icon';
import Button from 'components/Button';
import GetFreeTrialButton from 'components/GetFreeTrialButton';
import useGetFreeTrialInfo from 'hooks/useGetFreeTrialInfo';
import useStyles from 'hooks/useStyles';
import ContextStore from 'utils/createContext';

import styles from './Questions.scss';

const Questions = () => {
  useStyles(styles);
  const dispatch = useDispatch();
  const faqs = useSelector(getLiveFAQs);
  const { id, name } = useSelector(getLiveTopicInfo);

  const { isTopicEnrolled } = useContext(ContextStore);

  const { t } = useTranslation(['live']);
  const { faqTitleText, faqCTAText } = useGetFreeTrialInfo();

  const onQuestionClick = () => {
    dispatch(openSocialWidget());
  };

  return (
    <section className={styles.root}>
      <h2 className={styles.title}>{t('topic.overview.detail.faq')}</h2>
      <Accordion items={faqs} defaultActiveKey={faqs[0]?.key} />
      <div className={styles.question}>
        <QuestionIcon />
        <div className={styles.questionHint}>
          {isTopicEnrolled ? t('topic.faqHelp.question') : faqTitleText}
        </div>
        <div className={styles.buttonGroup}>
          <GetFreeTrialButton
            isShow={!isTopicEnrolled}
            type="regular_class"
            id={id}
            name={name}
            section="faq"
          />
          <Button reversed text={faqCTAText} onClick={onQuestionClick} />
        </div>
      </div>
    </section>
  );
};

export default Questions;
